import React from 'react';
import { auth, googleProvider, db } from '../firebase';
import { signInWithPopup } from 'firebase/auth';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const LoginScreen = () => {
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      // ── לוג כניסת משתמש (ברקע, שקוף למשתמש) ──
      addDoc(collection(db, 'logs'), {
        level: 'info',
        event: 'user_login',
        userDetails: {
          name:     user.displayName || 'Unknown',
          email:    user.email       || 'Unknown',
          photoURL: user.photoURL    || '',
          uid:      user.uid,
        },
        timestamp: serverTimestamp(),
      }).catch(e => console.warn('Login log failed:', e.message));

    } catch (error) {
      console.error('Login error:', error);
      alert('שגיאה בהתחברות. נסה שוב.');
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-6 font-body" dir="rtl">

      {/* ── Background decoration ── */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-primary-container/20 rounded-full blur-3xl" />
      </div>

      <div className="relative w-full max-w-md">

        {/* ── Logo / Brand ── */}
        <div className="text-center mb-10">
          <div className="w-20 h-20 bg-gradient-to-br from-primary to-primary-container rounded-full flex items-center justify-center mx-auto mb-5 shadow-xl shadow-primary/25">
            <span
              className="material-symbols-outlined text-white text-4xl"
              style={{ fontVariationSettings: "'FILL' 1" }}
            >
              restaurant
            </span>
          </div>
          <h1 className="text-4xl font-headline font-extrabold tracking-tight text-primary mb-2">
            CookWithAI
          </h1>
          <p className="text-on-surface-variant text-base font-medium">
            הפוך כל סרטון למתכון מושלם
          </p>
        </div>

        {/* ── Card ── */}
        <div className="bg-surface-container-lowest rounded-xl p-8 recipe-card-shadow">

          {/* Features list */}
          <div className="space-y-4 mb-8">
            {[
              { icon: 'auto_awesome', text: 'חילוץ מתכונים מאינסטגרם, טיקטוק ופייסבוק' },
              { icon: 'menu_book', text: 'ספר מתכונים אישי מאורגן לפי קטגוריות' },
              { icon: 'favorite', text: 'שמור מועדפים ודרג מתכונים' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <span className="material-symbols-outlined text-primary text-lg">{item.icon}</span>
                </div>
                <span className="text-on-surface font-medium text-sm leading-snug">{item.text}</span>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="flex items-center gap-3 mb-6">
            <div className="flex-1 h-px bg-outline-variant/40" />
            <span className="text-xs font-semibold text-outline uppercase tracking-widest">התחבר עם</span>
            <div className="flex-1 h-px bg-outline-variant/40" />
          </div>

          {/* Google Login Button */}
          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 py-4 bg-surface-container-low hover:bg-surface-container border border-outline-variant/30 rounded-full font-label font-bold text-on-surface text-base transition-all active:scale-95 hover:shadow-md"
          >
            {/* Google SVG */}
            <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            התחבר עם Google
          </button>
        </div>

        {/* ── Footer note ── */}
        <p className="text-center text-xs text-outline mt-6 leading-relaxed">
          בהתחברות אתה מסכים ל
          <span onClick={() => navigate('/terms')} className="text-primary font-semibold cursor-pointer"> תנאי השימוש </span>
          ול
          <span onClick={() => navigate('/privacy')} className="text-primary font-semibold cursor-pointer"> מדיניות הפרטיות</span>
        </p>
      </div>
    </div>
  );
};

export default LoginScreen;
